import { AppBar, makeStyles, createStyles, Theme, Toolbar } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    topbar: {
      backgroundColor: '#232323',// theme.palette.primary.dark, //theme.palette.common.black,
      color: theme.palette.common.white,
    },
    toolbar: {
      minHeight: '30px',
      justifyContent: 'flex-end',
      marginRight: theme.spacing(1),
    },
  })
);

const TopBar: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <AppBar position="fixed" className={classes.topbar}>
      <Toolbar variant="dense" className={classes.toolbar}>
        {children}
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
